import useMediaQuery from './useMediaQuery';
export default () => useMediaQuery('(max-width: 450px)');